import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import routes from '../routes/routes'
import alertService from '../services/alert.service'
import storageService from '../services/storage.service'
import subscriptionApi, { UserPendingPaymentRequest } from '../apis/subscriptionApi'
import {  SubscriptionPackage } from '../apis/subscriptionApi'
import { Elements } from '@stripe/react-stripe-js';
import { Stripe, loadStripe } from '@stripe/stripe-js';
import Card from '../components/Card'
import CardButton from '../components/CardButton'
import PageHeading from '../components/PageHeading'
import Row from '../components/Row/Row'
import Heading from '../components/Heading'
import Logo from '../components/Logo'
import SubscriptionSelector from '../components/SubscriptionSelector/SubscriptionSelector'
import InjectedCheckoutForm from '../partials/PaymentForm'
import authService from '../services/auth.service'
import LoadingOverlay from '../components/LoadingOverlay/LoadingOverlay'
import { ConfirmParams } from '../components/Confirm/Confirm.state'
import confirmService from '../services/confirm.service'

interface Props extends RouteComponentProps {}

interface State {
  isTrial: boolean
  mainPage: boolean
  paymentPage: boolean
  subscriptionPackages: SubscriptionPackage[]
  amountSelected: number,
  selectedSubscriptionId : number
  stripe: Stripe | null
  clientSecret: string
  isLoading: boolean
  currentPrice: string
  currentMembershipName: string
  status: string
}

const stripePromise = loadStripe('pk_live_51OdyiFB1SCFKDF5MhFPqWS2CJPcpxr7vWXUyXrumw8JZ3QYBuBeZdp8jBOCcNQ6Dpvzk0ucZrRbP573DbBh85dJX00tLiMBHM6');

class UserSubscriptionLayout extends Component<Props, State> {
  initialState: State = {
    isTrial: false,
    mainPage: true,
    paymentPage: false,
    subscriptionPackages: [],
    amountSelected: 0,
    selectedSubscriptionId : 0,
    stripe: null,
    clientSecret: '',
    isLoading: false,
    currentPrice: '',
    currentMembershipName: '',
    status: ''
  }

  constructor (props: Props) {
    super(props)
    this.state = this.initialState
    this.handleSubscribeClick = this.handleSubscribeClick.bind(this)
    this.handleSelectSubscription = this.handleSelectSubscription.bind(this)
    this.handleCancelSubscription = this.handleCancelSubscription.bind(this) 
    this.doCancel = this.doCancel.bind(this) 
  }

  componentDidMount(): void {
    stripePromise.then(stripe => {
      this.setState({ stripe });
    });

    const authData = authService.tokenData()
    if (!authData) return
    const { id } = authData

    subscriptionApi.getActiveMembership(id, membership => {
      if(membership?.type == 'trial'){
        subscriptionApi.list(subscriptions => {
          if (!subscriptions) return
          this.setState({isTrial: true, subscriptionPackages : subscriptions, mainPage: true})
        })
      } else {
        this.setState({isTrial: false, mainPage: true, currentPrice: membership?.price ?? '', currentMembershipName: membership?.name ?? '', status: membership?.status ?? ''})
      }
    })
  }

  handleSubscribeClick() {
    this.setState({isLoading:true})
    const authData = authService.tokenData()
    if (!authData) return
    const { id } = authData

    if(this.state.selectedSubscriptionId == 0){
      alertService.warning(i18n("Please select a subscription plan"));
      this.setState({isLoading: false})
      return;
    }

    const payload: UserPendingPaymentRequest = {amount: this.state.amountSelected, packageId: this.state.selectedSubscriptionId, id: id}
    subscriptionApi.userPaymentIntent(payload, pendingPayment => {
      this.setState({isLoading: false})
      if(!pendingPayment) return;
      this.setState({mainPage:false, paymentPage: true, clientSecret: pendingPayment.client_secret, isLoading: false})
    })
  }

  handleSelectSubscription = (subscriptionId: number, amount: number) => {
    console.log('Selected subscription ID:', subscriptionId);
    this.setState({selectedSubscriptionId: subscriptionId, amountSelected: amount})
  };

  handleCancelSubscription(){
    const authData = authService.tokenData()
    if (!authData) return
    const { id } = authData

    const confirm: ConfirmParams = {
      id,
      type: 'warning',
      question: i18n('Are you sure you want to cancel your subscription to QPRO+?'),
      confirmText: i18n('Yes'),
      cancelText: i18n('No'),
      onConfirm: () => this.doCancel(id)
    }
    confirmService.push(confirm)
  }

  doCancel(id: number){
    this.setState({isLoading : true})
    subscriptionApi.cancelSubscription(id, canceledSubscription => {
      this.setState({isLoading: false})
      if(!canceledSubscription) return;
      
      alertService.success(i18n("Membership canceled correctly. A confirmation e-mail has been sent."));

      //Log out user
      storageService.remove('authToken')
      this.props.history.push(routes.signIn)
    })
  }

  getTrialScreen(){
    if(this.state.isTrial && this.state.mainPage){
      return (
        <div className='flex justify-between mb-5'>
          {this.state.isLoading && <LoadingOverlay />}
          <div>
            <Heading
              text='QPRO+ Limited'
              className='text-theme' />
            <div className="text-secondary">
              {i18n('You have no active plans.')}<br/>{i18n('You are running in a limited version.')}
              <br />
            </div>
            <br /><br />
            <Row column={1}>
              <SubscriptionSelector
                subscriptions={this.state.subscriptionPackages} 
                onSelectSubscription={this.handleSelectSubscription} 
                selectedSubscriptionId={this.state.selectedSubscriptionId}
              /><br/><br/>
            </Row>
            <Row column={1}>
              <CardButton
                proceedText={i18n("Subscribe")}
                onProceedClick={this.handleSubscribeClick} />
            </Row>
          </div>
        </div>
      );
    }
  }

  getPaymentScreen(){
    if(this.state.paymentPage){
      const { stripe, clientSecret } = this.state;

      const options = {
        clientSecret: clientSecret,
      };

      return (
        <div>
          <Elements stripe={stripe} options={options}>  
            <InjectedCheckoutForm />
          </Elements>
        </div>
      );
    }
  }

  getCanceledScren(){
    if(!this.state.isTrial && this.state.mainPage && this.state.status === 'pendingCancel'){
      var { currentPrice, currentMembershipName } = this.state
      currentMembershipName = 'QPRO+ '+currentMembershipName
      return (
        <div className='flex justify-between mb-5'>
          {this.state.isLoading && <LoadingOverlay />}
          <div>
            <Heading
              text={currentMembershipName}
              className='text-theme' />
            <div className="text-secondary">
              Your subscription has been canceled.
              <br />
            </div>
            <br /><br />
          </div>
        </div>
      );
    }
  }

  getMembershipScreen(){
    if(!this.state.isTrial && this.state.mainPage && this.state.status === 'active'){
      var { currentPrice, currentMembershipName } = this.state
      currentMembershipName = 'QPRO+ '+currentMembershipName
      return (
        <div className='flex justify-between mb-5'>
          {this.state.isLoading && <LoadingOverlay />}
          <div>
            <Heading
              text={currentMembershipName}
              className='text-theme' />
            <div className="text-secondary">
              Your current plan is a paid monthly subscription.<br/>The monthly pament amount is ${currentPrice}.
              <br />
            </div>
            <br /><br />
            <Row column={1}>
              <CardButton
                proceedText={i18n("Cancel subscription")}
                onProceedClick={this.handleCancelSubscription} />
            </Row>
          </div>
        </div>
      );
    }
  }

  render () {
    return (
      <Card>
        <PageHeading text={i18n("My subscription")} />
        {this.getMembershipScreen()}
        {this.getTrialScreen()}
        {this.getPaymentScreen()}
        {this.getCanceledScren()}
      </Card>
    )
  }
}

export default withRouter(UserSubscriptionLayout)
